import Cookies from "js-cookie";

const AccessTokenKey = "t2_access_token";
const RefreshTokenKey = "t2_refresh_token";

export function getToken() {
  return Cookies.get(AccessTokenKey);
}

export function setToken(token) {
  return Cookies.set(AccessTokenKey, token);
}

export function removeToken() {
  return Cookies.remove(AccessTokenKey);
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token);
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey);
}

const UsernameKey = "t2_username";

export function getUsername() {
  return Cookies.get(UsernameKey);
}

export function setUsername(username) {
  return username
    ? Cookies.set(UsernameKey, username)
    : Cookies.remove(UsernameKey);
}

export function removeUsername() {
  return Cookies.remove(UsernameKey);
}
